import { connect } from 'react-redux';
import { get } from 'lodash';
import { actions } from 'Data/actions';
import PractitionerDashboard from './component';

export default connect((state) => ({
  incomingPatientCode: get(state, ['Meeting', 'dataBridgeCode']),
  incomingPatientShowError: get(state, ['Meeting', 'dataBridgeShowError']),
}), (dispatch) => ({
  meetingPutPatientDetails: (code) => dispatch(actions.meetingPutPatientDetails(code)),
  openDeviceSettingsModal: () => dispatch(actions.modalOpen({
    id: 'deviceSettings',
  })),
}))(PractitionerDashboard);
